// Orchestrator. Replaces js/src/sales-locator.js, but with no jQuery and
// no global properties — config is captured in a module-scoped object.

import { validateOptions } from './validator.js';
import { buildFinder, loadStyles } from './template.js';
import { bindSubmit } from './events.js';

const config = {
  apiUrl: null,
  apiKey: null,
};

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  }
}

function getUrlVars() {
  const vars = {};
  const params = new URLSearchParams(window.location.search);
  for (const [k, v] of params.entries()) vars[k] = v;
  return vars;
}

function start() {
  ready(() => {
    buildFinder();
    loadStyles();
    bindSubmit(config.apiUrl, config.apiKey);

    // If ?query=12345 is on the URL, prefill and submit.
    const urlVars = getUrlVars();
    if (urlVars.query) {
      const input = document.getElementById('LocationQuery');
      const form = document.querySelector('.locations-search form');
      if (input) input.value = urlVars.query;
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });
}

export function build(options) {
  if (!validateOptions(options)) {
    if (window.console && console.log) {
      console.log('Not a valid embed code. Please see documentation.');
    }
    return;
  }
  config.apiUrl = options.api_endpoint;
  config.apiKey = options.api_key;
  start();
}
